import { takeEvery, put } from 'redux-saga/effects';
import { API, STATUS, Urls } from '@vezeeta/web-utils';

import { COUNTRY, CITY } from '../actions/country';
import CoustomUrls from '../../urls';

function* getCountries() {
  try {
    const apiObj = new API();
    const res = yield apiObj.get(Urls.country.getCountries, undefined, true);
    if (STATUS.isSuccess(res.status)) {
      yield put({ type: COUNTRY.LOAD_DONE, countries: res.data });
    } else {
      yield put({ type: COUNTRY.LOAD_FAIL });
    }
  } catch (err) {
    yield put({ type: COUNTRY.LOAD_FAIL });
  }
}

function* getCountryList() {
  try {
    const apiObj = new API();
    const res = yield apiObj.get(Urls.getCountryList, undefined, true);
    if (STATUS.isSuccess(res.status)) {
      yield put({ type: COUNTRY.LOAD_LIST_DONE, countries: res.data });
    } else {
      yield put({ type: COUNTRY.LOAD_LIST_FAIL });
    }
  } catch (err) {
    yield put({ type: COUNTRY.LOAD_LIST_FAIL });
  }
}

function* getCities() {
  try {
    const apiObj = new API();
    const res = yield apiObj.get(Urls.getAreas, undefined, true);
    if (STATUS.isSuccess(res.status)) {
      yield put({ type: CITY.LOAD_DONE, cities: res.data });
    } else {
      yield put({ type: CITY.LOAD_FAIL });
    }
  } catch (err) {
    yield put({ type: CITY.LOAD_FAIL });
  }
}

function* getCitiesAreas(action) {
  try {
    const apiObj = new API();
    const res = yield apiObj.get(
      `${CoustomUrls.GetCitiesAreasByBookingType}?&BookingType=3&countryid=${action.countryId}`
    );
    if (STATUS.isSuccess(res.status)) {
      yield put({ type: CITY.LOAD_DONE, cities: res.data });
    } else {
      yield put({ type: CITY.LOAD_FAIL });
    }
  } catch (err) {
    yield put({ type: CITY.LOAD_FAIL });
  }
}

export default function* country() {
  yield takeEvery(COUNTRY.LOAD, getCountries);
  yield takeEvery(COUNTRY.LOAD_LIST, getCountryList);
  yield takeEvery(CITY.LOAD, getCitiesAreas);
}
